import { render, staticRenderFns } from "./SeatsColumn.vue?vue&type=template&id=229641e1&"
import script from "./SeatsColumn.vue?vue&type=script&lang=js&"
export * from "./SeatsColumn.vue?vue&type=script&lang=js&"
import style0 from "./SeatsColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229641e1')) {
      api.createRecord('229641e1', component.options)
    } else {
      api.reload('229641e1', component.options)
    }
    module.hot.accept("./SeatsColumn.vue?vue&type=template&id=229641e1&", function () {
      api.rerender('229641e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/SeatsColumn.vue"
export default component.exports